import { CreateFAQDto } from "@/services/interfaces/IFAQService";

interface NewFaqFields {
  question: string;
  answer: string;
}

/**
 * A new FAQ question goes out starred: guests see only starred questions in starred categories
 * (DV-57), so an unstarred one stays hidden.
 */
export const newFaqPayload = (
  { question, answer }: NewFaqFields,
  categoryId: string,
): CreateFAQDto => ({
  question: question.trim(),
  answer: answer.trim(),
  categoryId,
  isPriority: true,
  isArchived: false,
});
